(() => {
  try {
    const revision = 'app-screen-20261012';
    if (sessionStorage.getItem('solstice-app-screen-revision') !== revision) {
      for (let i = sessionStorage.length - 1; i >= 0; i--) {
        const key = sessionStorage.key(i);
        if (key?.startsWith('ear_config_html_')) sessionStorage.removeItem(key);
      }
      sessionStorage.setItem('solstice-app-screen-revision', revision);
    }
  } catch (_) {}

  const isNative = () => Boolean(window.SolsticeBridge || window.SolsticeNative || window.webkit?.messageHandlers?.solstice || /Solstice-(?:Android|iOS)\//i.test(navigator.userAgent));
  const sync = () => document.documentElement.classList.toggle('solstice-native-app', isNative());
  sync();
  document.addEventListener('DOMContentLoaded', sync, { once: true });
  window.addEventListener('pageshow', sync);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.solstice-app-download--desktop[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.solstice-app-download--desktop[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();

// Direct store QR codes inside each desktop platform card.
(() => {
  const images = {
    ios: 'https://cdn.shopify.com/s/files/1/0889/5066/9656/files/solstice-iphone-direct-qr.png?v=1792029009',
    android: 'https://cdn.shopify.com/s/files/1/0889/5066/9656/files/solstice-android-direct-qr.png?v=1792029014'
  };
  function enhance(root) {
    if (!root?.querySelectorAll || !document.createElement) return;
    const stores = [...root.querySelectorAll('.solstice-app-download__store')];
    if (root.matches?.('.solstice-app-download__store')) stores.unshift(root);
    for (const store of stores) {
      if (store.parentElement?.classList.contains('solstice-app-card')) continue;
      const platform = store.href.includes('apps.apple.com/') ? 'ios' : store.href.includes('play.google.com/') ? 'android' : null;
      if (!platform) continue;
      const img = document.createElement('img');
      img.className = 'solstice-app-qr';
      img.setAttribute('data-app-qr', platform);
      img.src = images[platform]; img.alt = platform === 'ios' ? 'QR App Store' : 'QR Google Play';
      img.width = 144; img.height = 144; img.loading = 'lazy';
      const card = document.createElement('div');
      card.className = 'solstice-app-card';
      store.replaceWith(card);
      card.append(store, img);
    }
  }
  function start() {
    enhance(document);
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1 && !node.matches?.('[data-app-qr]') && !node.closest?.('.solstice-app-card')) roots.add(node);
      }
      for (const node of roots) {
        let nested = false;
        for (let parent = node.parentElement; parent; parent = parent.parentElement) {
          if (roots.has(parent)) { nested = true; break; }
        }
        if (!nested) enhance(node);
      }
    }).observe(document.body, {childList:true, subtree:true});
  }
  document.addEventListener('DOMContentLoaded', start, {once:true});
  if (document.readyState && document.readyState !== 'loading') start();
})();
